export const renderEstadoDoc = (
    data: any,
    opciones: { esTransaccion?: boolean, esDocRelacionado?: boolean, addClass?: string } = {}
  ): any => {
    const { estadoanulacion, detallenota, notificarcorreo, anulado, estado } = data;
    const ajustado = detallenota?.some((nota: any) => nota.estado !== "RECHAZADO") ?? false;
    let divEstado;
  
    if (estadoanulacion === "true" || anulado === "true") {
      divEstado = <div className={`lista-facturas-estado documento-anulado ${opciones.addClass}`}>{'Anulado'}</div>;
    } else if (ajustado) {
      divEstado = <div className={`lista-facturas-estado documento-ajustado ${opciones.addClass}`}>{'Ajustado'}</div>;
    } else if (estado === "RECHAZADO") {
      divEstado = <div className={`lista-facturas-estado documento-correo-invalido ${opciones.addClass}`}>{'Rechazado'}</div>;
    } else {
      divEstado = <div className={`lista-facturas-estado documento-activo ${opciones.addClass}`}>{'Procesado'}</div>;
    }
  
    if (opciones.esTransaccion && notificarcorreo?.length > 0) {
      divEstado = (
        <>
          {divEstado}
          <div className='lista-facturas-estado documento-correo-invalido'>{'Fallo Último Correo'}</div>
        </>
      );
    }
  
    return divEstado;
  };
